var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcSearch32 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51504F",
    fillRule: "evenodd",
    d: "M6.667 14.667c0-4.412 3.588-8 8-8s8 3.588 8 8-3.588 8-8 8-8-3.588-8-8zm20.942 11.057l-4.526-4.528c1.404-1.805 2.25-4.068 2.25-6.53C25.333 8.787 20.548 4 14.667 4 8.785 4 4 8.785 4 14.667c0 5.881 4.785 10.666 10.667 10.666 2.461 0 4.724-.846 6.529-2.25l4.528 4.526c.26.26.601.391.943.391.341 0 .682-.13.942-.39.522-.522.522-1.365 0-1.886z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcSearch32, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_search_32.e22621be.svg";
export { ForwardRef as ReactComponent };